<script setup lang="ts">
  import { computed, defineAsyncComponent, onMounted, ref } from 'vue'
  import { useApiRequestsAbort, usePerformanceTiming } from '@/shared/composables'
  import { useCommonStore, useFeaturesStore } from '@/shared/store'
  import { TravelDirection } from '@/shared/types/common.types'
  import { useFormDataWithRedirect } from '@/shared/composables/useFormDataWithRedirect'

  // import { useApiRequestsAbort, useWinterSport } from '@/shared/composables';

  const emit = defineEmits<Emits>()
  const FlowPersonalInformationWidgetQC = defineAsyncComponent(
    () =>
      import('@/widgets/Flow/FlowPersonalInformationWidgetQC/FlowPersonalInformationWidgetQC.vue')
  )
  const FlowPersonalInformationWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowPersonalInformationWidget/FlowPersonalInformationWidget.vue')
  )
  interface Emits {
    (e: 'load', request: () => Promise<any>, requestId?: string): void
  }
  useApiRequestsAbort()

  const { getFormData } = useFormDataWithRedirect()
  const commonStore = useCommonStore()
  const { onPerformanceCheckEnd } = usePerformanceTiming()
  const featuresStore = useFeaturesStore()
  // const { withWinterSport, fetchWinterSportPrice } = useWinterSport();
  const isPersonalInformationQcEnabled = computed(
    () => featuresStore.isPersonalInformationQcEnabled
  )

  const winterSportPrice = ref(0)
  const loadingFormData = ref(true)
  const nationalities = computed(() => commonStore.nationalities)

  const fetchNationalities = async () => {
    if (nationalities.value.length > 0) return

    const data = await commonStore.findNationalities()
    commonStore.setNationalities(data)
  }

  onMounted(() => {
    // if (withWinterSport.value) {
    //   emit(
    //     'load',
    //     async () => {
    //       winterSportPrice.value = await fetchWinterSportPrice();
    //     },
    //     'fetchWinterSportPrice'
    //   );
    // }

    emit(
      'load',
      async () => {
        if (!(await getFormData(TravelDirection.OUTBOUND, true, true))) return
        loadingFormData.value = false
        await fetchNationalities()
        onPerformanceCheckEnd()
      },
      'getNationalities'
    )
  })
</script>

<template>
  <FlowPersonalInformationWidgetQC
    v-if="isPersonalInformationQcEnabled"
    :with-winter-sport="false"
    :winter-sport-price="winterSportPrice"
    :loading-form-data="loadingFormData"
    @load="emit('load', $event)"
  />
  <FlowPersonalInformationWidget
    v-else
    :with-winter-sport="false"
    :winter-sport-price="winterSportPrice"
    :loading-form-data="loadingFormData"
    @load="emit('load', $event)"
  />
</template>
